// ContentMixStep.tsx — step 'content-mix' del onboarding.
// Qué hace: checkboxes de categorías de contenido (auto-balanceadas) + resumen y
//   botón de creación final.
// Qué exporta: ContentMixStep.
// Quién lo usa: CreateWorkspaceModal.

import { Button } from '../../Button';
import { ContentMix } from '../types';
import { MixCheckboxGrid, MixCheckItem, MixCheckbox, MixLabel, MixHint, MixSummary } from '../styled';

interface Props {
  contentMix: ContentMix;
  checkedCategories: Set<keyof ContentMix>;
  toggleCategory: (cat: keyof ContentMix) => void;
  isCreating: boolean;
  handleCreate: () => void;
}

export function ContentMixStep({
  contentMix, checkedCategories, toggleCategory, isCreating, handleCreate,
}: Props) {
  return (
    <>
      <MixCheckboxGrid>
        {([
          { key: 'education' as const, label: 'Education', hint: 'Tips, how-tos' },
          { key: 'connection' as const, label: 'Connection', hint: 'Community, story' },
          { key: 'proof' as const, label: 'Proof', hint: 'Testimonials, results' },
          { key: 'promotion' as const, label: 'Promotion', hint: 'Sales, CTAs' },
        ]).map(({ key, label, hint }) => (
          <MixCheckItem key={key} $checked={checkedCategories.has(key)}>
            <MixCheckbox
              type="checkbox"
              checked={checkedCategories.has(key)}
              onChange={() => toggleCategory(key)}
            />
            <div>
              <MixLabel>{label}</MixLabel>
              <MixHint> — {hint}</MixHint>
            </div>
          </MixCheckItem>
        ))}
      </MixCheckboxGrid>
      <MixSummary>
        {Array.from(checkedCategories).map(c => `${c.charAt(0).toUpperCase() + c.slice(1)} ${contentMix[c]}%`).join(' · ')}
      </MixSummary>
      <Button type="button" onClick={handleCreate} disabled={isCreating || checkedCategories.size === 0}
        style={{ width: '100%', marginTop: 8 }}>
        {isCreating ? 'Creating...' : 'Create Workspace'}
      </Button>
    </>
  );
}
